<template>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <div class="text-center">
      <div class="text-6xl mb-6">📋</div>
      <h1 class="text-4xl font-bold text-gray-900 mb-4">Packliste</h1>
      <p class="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
        Create organized packing lists with categories and items. 
        Share them with others and track your packing progress.
      </p>
      
      <div class="max-w-md mx-auto space-y-4">
        <button
          @click="createNewList"
          class="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-4 px-8 rounded-lg transition-colors text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
        >
          ✨ Create New Packing List
        </button>
        
        <router-link
          to="/overview"
          class="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-6 rounded-lg transition-colors text-base shadow hover:shadow-lg transform hover:-translate-y-0.5 flex items-center justify-center"
        >
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
          View All Lists
        </router-link>
      </div>
      
      <div class="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
        <div class="text-center">
          <div class="text-3xl mb-2">📝</div>
          <h3 class="font-semibold text-gray-900 mb-2">Organize</h3>
          <p class="text-gray-600 text-sm">Create categories and add items with quantities and notes</p>
        </div>
        <div class="text-center">
          <div class="text-3xl mb-2">☑️</div>
          <h3 class="font-semibold text-gray-900 mb-2">Track Progress</h3>
          <p class="text-gray-600 text-sm">Check off items as you pack and see your progress</p>
        </div>
        <div class="text-center">
          <div class="text-3xl mb-2">🔗</div>
          <h3 class="font-semibold text-gray-900 mb-2">Share</h3>
          <p class="text-gray-600 text-sm">Share lists with friends and family via unique URLs</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { generateId } from '@/utils/helpers'

const router = useRouter()

const createNewList = () => {
  router.push({ name: 'packing-list', params: { id: 'new' } })
}
</script>